import {
  COJG_FINANCIAL_GET_LIST,
  COJG_FINANCIAL_GET_LIST_SUCCESS,
  COJG_FINANCIAL_GET_LIST_ERROR,
  COJG_FINANCIAL_GET_LIST_WITH_FILTER,
  COJG_FINANCIAL_GET_LIST_WITH_ORDER,
  COJG_FINANCIAL_GET_LIST_SEARCH,
} from '../../actions';

const INIT_STATE = {
  cojgFinancials: [],
  cojgFinancial: [],
  error: '',
  filter: null,
  searchKeyword: '',
  orderColumn: null,
  loading: false,
  labels: [
    { label: 'EDUCATION', color: 'secondary' },
    { label: 'NEW FRAMEWORK', color: 'primary' },
    { label: 'PERSONAL', color: 'info' },
  ],
  orderColumns: [
    { column: 'id', label: 'Id' },
    { column: 'name', label: 'Name' },
    { column: 'hid', label: 'HST' },
    { column: 'pcc', label: 'PCC' },
    { column: 'note', label: 'Note' },
  ],
  categories: ['Flexbox', 'Sass', 'React'],
  selectedItems: [],
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case COJG_FINANCIAL_GET_LIST:
      return { ...state, loading: false };

    case COJG_FINANCIAL_GET_LIST_SUCCESS:
      return {
        ...state,
        loading: true,
        cojgFinancials: action.payload,
        cojgFinancial: action.payload,
      };

    case COJG_FINANCIAL_GET_LIST_ERROR:
      return { ...state, loading: true, error: action.payload };

    case COJG_FINANCIAL_GET_LIST_WITH_FILTER:
      if (action.payload.column === '' || action.payload.value === '') {
        return { ...state, loading: true, cojgFinancial: state.cojgFinancials, filter: null };
      } else {
        const filteredItems = state.cojgFinancials.filter(
          item => item[action.payload.column] === action.payload.value
        );
        return {
          ...state,
          loading: true,
          cojgFinancial: filteredItems,
          filter: {
            column: action.payload.column,
            value: action.payload.value,
          },
        };
      }

    case COJG_FINANCIAL_GET_LIST_WITH_ORDER:
      if (action.payload === '') {
        return { ...state, loading: true, cojgFinancial: state.cojgFinancial, orderColumn: null };
      } else {
        const sortedItems = state.cojgFinancial.sort((a, b) => {
          if (a[action.payload] < b[action.payload]) return -1;
          else if (a[action.payload] > b[action.payload]) return 1;
          return 0;
        });
        return {
          ...state,
          loading: true,
          COJG_FINANCIAL: sortedItems,
          orderColumn: state.orderColumns.find(x => x.column === action.payload),
        };
      }

    case COJG_FINANCIAL_GET_LIST_SEARCH:
      if (action.payload === '') {
        return { ...state, cojgFinancial: state.cojgFinancials };
      } else {
        const keyword = action.payload.toLowerCase();
        const searchItems = state.cojgFinancials.cojgContracts.filter(
          item =>
            String(item.id).startsWith(keyword) ||
            String(item.company.toLowerCase()).startsWith(keyword) ||
            String(item.trainingStartDate).startsWith(keyword) ||
            String(item.contractTier).startsWith(keyword) ||
            String(item.caMs).startsWith(keyword) ||
            String(item.revisedInKind).startsWith(keyword) ||
            String(item.revisedContractAmount).startsWith(keyword)
        );
        return {
          ...state,
          loading: true,
          cojgFinancial: searchItems,
          searchKeyword: action.payload,
        };
      }
    default:
      return { ...state };
  }
};
